<app-overlay
  *ngIf="useOverlay; else spinner"
  (close)="overlayClose()"
  [isTransparent]="hasTransparentOverlay"
  [isOpen]="isOpen"
>
  <ng-container *ngTemplateOutlet="spinner"></ng-container>
</app-overlay>

<ng-template #spinner>
  <div
    *ngIf="isOpen"
    class="ahe-ui-loading-spinner"
    [style.height.px]="size"
    [style.width.px]="size"
    (click)="close.emit()"
  >
    <div class="loader">
      <span *ngIf="hasTrappedFocus" cdkTrapFocus tabIndex="0" class="sr-only">
        {{ 'ngx-shared-content-is-loading' | translate | async }}
      </span>
      <span *ngIf="!hasTrappedFocus" tabIndex="0" class="sr-only">
        {{ 'ngx-shared-content-is-loading' | translate | async }}
      </span>
      <svg class="circular" viewBox="25 25 50 50" focusable="false" aria-hidden="true">
        <circle cx="50" cy="50" r="20" fill="none" stroke="white" stroke-width="2"></circle>
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        ></circle>
      </svg>
    </div>
  </div>
</ng-template>
